import Text from '@passkeys/ui/text';

import useTotalBalance from '@/ui/hooks/use-total-balance.js';
import { cn } from '@/ui/utils/classnames.js';
import BackButton from '../../back-button/index.js';
import FancyAmount, { FancyAmountSkeleton } from '../../fancy-amount/index.js';

type ResponsiveHeaderProps = {
  title: string;
  canClose?: boolean;
  onClose: () => void;
};

function ResponsiveHeader({ title, canClose, onClose }: ResponsiveHeaderProps) {
  const { value: totalBalance, loading: isTotalBalanceLoading } =
    useTotalBalance();

  return (
    <header className="flex flex-col p-6 md:gap-y-10 md:px-12 md:py-8">
      <div className="hidden md:block">
        {isTotalBalanceLoading ? (
          <FancyAmountSkeleton />
        ) : (
          <FancyAmount value={totalBalance.toDefaultNumber()} />
        )}
      </div>

      <div
        className={cn(
          'grid grid-cols-[1fr_auto_1fr] items-center md:grid-cols-[auto_1fr]',
          canClose && 'gap-x-4',
        )}
      >
        <BackButton
          onClick={() => onClose()}
          className={cn(!canClose && 'invisible md:w-0')}
        />
        <Text as="h1">{title}</Text>
      </div>
    </header>
  );
}

export default ResponsiveHeader;
